import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Tab } from "@mui/material";

import Sidebar from "../../../components/Sidebar";
import TabTittle from "../../../components/Text/TabTittle";
import NoPermission from "../../../components/Erros/NoPermission";
import ViewExternalScreen from "../../../components/ViewExternalScreen";
import { ApplicationState } from "../../../store";
import FacebookCircularProgress from "../../../components/Loading";
import { checkViewPermission } from "../../../utils/permissions";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  loadRequest as loadRequestMonitoring
} from "../../../store/ducks/monitoring/actions";

export default function MonitoringDashboard() {
  const [valueTab, setValueTab] = useState("5");
  const [tabs, setTabs] = useState([]);
  const [valueSubTab, setValueSubTab] = useState("0");
  const [externalScreenURL, setExternalScreenURL] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [refetch, setRefetch] = useState(false);
  const rightsOfLayoutState = useSelector(
    (state: ApplicationState) => state.layout.data.rights
  );

  const dispatch = useDispatch();

  const monitoringState = useSelector(
    (state: ApplicationState) => state.monitoring
  );

  useEffect(() => {
    dispatch(loadRequestMonitoring({}))
  }, []);
  
  useEffect(() => {
    if (monitoringState.success) {
      const defaultTab = monitoringState?.data?.data?.default_loading_tab;
      const defaultSubTab = monitoringState?.data?.data?.default_loading_sub_tab;
      setTabs(monitoringState?.data?.data?.tabs);
      setValueTab(monitoringState?.data?.data?.tabs[defaultTab].id);
      setValueSubTab(monitoringState?.data?.data?.tabs[defaultTab].sub_tabs[defaultSubTab].id);
      setExternalScreenURL(monitoringState?.data?.data?.tabs[defaultTab].sub_tabs[defaultSubTab].url);
    }
  }, [monitoringState.success]);
  
  useEffect(() => {
    if (valueTab === "5" && tabs[5]?.subTabs?.length > 0) {
      const firstSubTab = tabs[5].subTabs[0];
      setValueSubTab(firstSubTab.id);
      setExternalScreenURL(firstSubTab.url);
    }
  }, [valueTab]);

  // const tabs = [
  //   { id: "0", label: "Agenda", subTabs: [], active: false },
  //   { id: "1", label: "Elegíveis", subTabs: [], active: false },
  //   { id: "2", label: "Triagem", subTabs: [], active: false },
  //   { id: "3", label: "Mensageria", subTabs: [], active: false },
  //   { id: "4", label: "Consultas Agendadas", subTabs: [], active: false },
  //   {
  //     id: "5",
  //     label: "Cockpit",
  //     active: true,
  //     subTabs: [
  //       {
  //         id: "0",
  //         label: "Total de DRG",
  //         url: "https://app.powerbi.com/view?r=eyJrIjoiNTBmN2Y3OTctYzUzZC00ODU1LTgzMWEtY2E3ZjJjM2M0MWE0IiwidCI6IjQwNDU3MTE1LTFkZDYtNDRiMS1iYmNmLTNiZWIwNDI3Y2E5NyJ9",
  //         active: true,
  //       },
  //       {
  //         id: "1",
  //         label: "Situação demográfica",
  //         url: "link1",
  //         active: true,
  //       },
  //       {
  //         id: "2",
  //         label: "Visão das UBS",
  //         url: "link2",
  //         active: true,
  //       },
  //       {
  //         id: "3",
  //         label: "Lista de exames",
  //         url: "link3",
  //         active: true,
  //       },
  //     ],
  //   },
  // ];

  return (

    <Sidebar>
      {/* {loading && <FacebookCircularProgress />} */}
      {checkViewPermission("monitoring", JSON.stringify(rightsOfLayoutState)) ? (
        <Container>
          <TabTittle tittle={"Monitoramento Pós-Alta"} />

          <>

            <TabContext value={valueTab}>
              <TabList
                scrollButtons="auto"
                sx={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  p: 1,
                }}
              >
                {tabs.map(({ id, label, active }) => (
                  <Tab
                    key={id}
                    label={label}
                    id={`tab-${id}`}
                    value={id}
                    disabled={!active}
                    onClick={() => {
                      setLoading(true);
                      valueTab === id
                        ? (() => {
                          setValueTab(null);
                          setTimeout(() => setValueTab(id), 0);
                        })()
                        : setValueTab(id);
                    }}

                    sx={{
                      opacity: active ? 1 : 0.5,
                      cursor: active ? "pointer" : "not-allowed",
                      pointerEvents: active ? "auto" : "none",
                    }}
                  />
                ))}
              </TabList>

              <TabPanel value={valueTab} sx={{ textAlign: "left", p: 0 }}>
                {valueTab === "5" && (
                  <TabContext value={valueSubTab}>
                    <TabList
                      scrollButtons="auto"
                      sx={{
                        justifyContent: "flex-start",
                        "& .MuiTabs-flexContainer": {
                          justifyContent: "flex-start",
                        },
                      }}
                    >
                      {tabs[5]?.sub_tabs?.map(({ id, label, url }) => (
                        <Tab
                          key={"subTab" + id}
                          label={label}
                          value={id}
                          onClick={() => {
                            setLoading(true);
                            setValueSubTab(id);

                            valueSubTab === id
                              ? (setExternalScreenURL(null), setTimeout(() => setExternalScreenURL(url), 50))
                              : setExternalScreenURL(url);
                          }}

                          sx={{ alignItems: "flex-start" }}
                        />
                      ))}
                    </TabList>

                    <TabPanel value={valueSubTab} sx={{ textAlign: "left", p: 0 }}>
                      <ViewExternalScreen
                        url={externalScreenURL}
                        onLoaded={() => setLoading(false)}
                      />
                    </TabPanel>
                  </TabContext>
                )}
              </TabPanel>
            </TabContext>
          </>
        </Container>
      ) : (
        <NoPermission />
      )}
    </Sidebar>
  );
}

